import React, { useRef, useState, useCallback, useEffect } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";
import { topTen } from "../data/films";
import { FadeUp } from "./FadeUp";
export function TopTenRow() {
  const scroller = useRef<HTMLOListElement>(null);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(true);
  const update = useCallback(() => {
    const el = scroller.current;
    if (!el) return;
    setCanPrev(el.scrollLeft > 4);
    setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  }, []);
  useEffect(() => {
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, [update]);
  const scrollBy = (dir: 1 | -1) => {
    const el = scroller.current;
    if (el) el.scrollBy({
      left: dir * el.clientWidth * 0.8,
      behavior: "smooth"
    });
  };
  const title = "Top 5 formats brands ask us for";
  return <section id="formats" className="group/row relative scroll-mt-24" aria-label={title} data-id="element-365" data-mp="1ulf8umnjlnkw">
      <FadeUp data-id="element-366" data-mp="3ov8jfq24gghs">
        <div className="container-x mb-2 flex items-baseline gap-4" data-id="element-367" data-mp="3ovibdj6q8xq4">
          <h2 className="font-serif text-[20px] leading-tight tracking-[-0.01em] text-white md:text-[24px]" data-id="element-368" data-mp="3twxzxl845md9">{title}</h2>
        </div>
        <div className="relative" data-id="element-369" data-mp="7gv0zlqg99z7">
          <ol ref={scroller} onScroll={update} tabIndex={0} aria-label={`${title} — scroll horizontally`} className="row-pad no-scrollbar flex snap-x snap-proximity gap-2 overflow-x-auto overflow-y-hidden overscroll-x-contain touch-pan-x touch-pan-y [-webkit-overflow-scrolling:touch] py-3 md:gap-4" data-id="element-370" data-mp="7h3ixs1fj5h9">
            {topTen.map(item => <li key={item.rank} className="group/card flex shrink-0 snap-start items-end lg:min-w-0 lg:flex-1" data-id="element-371" data-mp="qeeeb1jxxerf">
                <span aria-hidden="true" className={`text-outline shrink-0 select-none font-serif text-[96px] leading-[0.8] tracking-[-0.06em] md:text-[150px] ${item.rank === 10 ? "-mr-4 md:-mr-6" : "-mr-3 md:-mr-5"}`} data-id="element-372" data-mp="2n9ka5oy7tv1b">
                  {item.rank}
                </span>
                <div className="relative aspect-[2/3] w-[128px] overflow-hidden bg-card md:w-[180px] lg:w-auto lg:min-w-0 lg:flex-1" data-id="element-373" data-mp="2u4u6nef2obm6">
                  <img src={item.image} alt={item.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-[250ms] ease-out group-hover/card:scale-[1.04]" data-id="element-374" data-mp="2p466o38v8kft" />
                  <div className="absolute inset-x-0 bottom-0 px-2.5 pb-2.5 pt-10" style={{
                background: "linear-gradient(0deg, rgba(0,0,0,0.9), rgba(0,0,0,0))"
              }} data-id="element-375" data-mp="3ctqtix8541ud">
                    <p className="font-mono text-[10px] leading-tight tracking-[0.08em] text-white md:text-[11px]" data-id="element-376" data-mp="3ltnm39xnhkup">
                      <span className="sr-only" data-id="element-377" data-mp="4d1hzep94cne">Number {item.rank}: </span>
                      {item.label}
                    </p>
                  </div>
                </div>
              </li>)}
          </ol>
          <button type="button" onClick={() => scrollBy(-1)} aria-label="Scroll top 10 left" disabled={!canPrev} className="absolute inset-y-0 left-0 hidden w-12 items-center justify-center bg-ink/70 text-white opacity-0 transition-opacity duration-150 focus:opacity-100 disabled:pointer-events-none disabled:!opacity-0 group-hover/row:opacity-100 md:flex" data-id="element-378" data-mp="3riace8y0lz2q">
            <ChevronLeftIcon className="h-8 w-8" data-id="element-379" data-mp="38skfngaoz386" />
          </button>
          <button type="button" onClick={() => scrollBy(1)} aria-label="Scroll top 10 right" disabled={!canNext} className="absolute inset-y-0 right-0 hidden w-12 items-center justify-center bg-ink/70 text-white opacity-0 transition-opacity duration-150 focus:opacity-100 disabled:pointer-events-none disabled:!opacity-0 group-hover/row:opacity-100 md:flex" data-id="element-380" data-mp="3cscuubulc7mi">
            <ChevronRightIcon className="h-8 w-8" data-id="element-381" data-mp="5zwd86n48sfa" />
          </button>
        </div>
      </FadeUp>
    </section>;
}